export const AUTOPLAY_INTERVAL_MS = 5000;
